import React from "react";
import gsap from "gsap";
import SplitText from "gsap/SplitText";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText, ScrollTrigger, useGSAP);
const SubHeading = ({ subheading }: { subheading: string }) => {
  const paragraphRef = React.useRef<HTMLParagraphElement>(null);
  useGSAP(() => {
    const paragraphText = new SplitText(paragraphRef.current, {
      type: "lines, words, chars",
    });
    gsap.from(paragraphText.words, {
      scrollTrigger: {
        trigger: paragraphRef.current,
        start: "bottom 85%",
        toggleActions: "play none none reverse",
        once: true,
      },
      y: "8vw",
      autoAlpha: 0,
      duration: 2,
      ease: "power3.out",
      stagger: {
        amount: 0.5,
      },
    });
  }, []);
  return (
    <p
      ref={(el) => {
        if (el) paragraphRef.current = el;
      }}
      className="common-subheading"
    >
      {subheading}
    </p>
  );
};

export default SubHeading;
